<template>
  <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.53611 7.87522L9.18563 7.75235L3.80884 5.86719L4.22198 10.5562C4.22198 11.4889 6.58453 12.2451 9.49976 12.2451C12.415 12.2451 14.7775 11.4889 14.7775 10.5562L15.1899 5.87795L9.88569 7.75157L9.53611 7.87522Z" fill="currentColor" />
    <path d="M18.1506 12.6667C18.1242 12.3756 17.9906 12.1167 17.7902 11.9278C18.0145 11.7159 18.1556 11.4165 18.1556 11.0834C18.1556 10.6323 17.8974 10.2422 17.5222 10.0501V3.93441L19 3.4124L9.53462 0L0 3.4124L9.53462 6.75556L16.4667 4.30709V10.0499C16.0915 10.2421 15.8333 10.6321 15.8333 11.0832C15.8333 11.4164 15.9743 11.7157 16.1987 11.9277C15.9983 12.1165 15.8647 12.3755 15.8383 12.6666H15.8333L15.6222 14.7777H18.3667L18.1556 12.6666L18.1506 12.6667Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'Education',
};
</script>
